// extracted by mini-css-extract-plugin
module.exports = {"rootContainer":"home-page_rootContainer__2Svfn","mentions":"home-page_mentions__2o8sI"};